import { Box, Button, Paper } from '@mui/material';
import styled from 'styled-components';

export const PageContainer = styled(Box)`
  padding: 16px;
  @media (max-width: 600px) {
    padding: 16px;
  }
`;

export const HeaderBox = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 16px;
  }
`;

export const PaperWrapper = styled(Paper)`
  padding: 32px;
  margin-bottom: 32px;
  border-radius: 16px;
  min-height: calc(100vh - 250px);
  display: flex;
  flex-direction: column;
  gap: 24px;
  @media (max-width: 600px) {
    padding: 16px;
    min-height: auto;
  }
`;

export const StyledButton = styled(Button).attrs({
  variant: 'contained',
  color: 'primary'
})({
  flexDirection: 'column-reverse',
  '@media (min-width: 0px)': {
    width: 'auto'
  }
});

export const SearchContainer = styled(Box)`
  display: flex;
  gap: 16px;
  align-items: center;
  width: 100%;
  @media (max-width: 600px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const ButtonBox = styled(Box)`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  width: 100%;
`;

export const FiltersContainer = styled(Box)`
  display: flex;
  gap: 16px;
  align-items: flex-end;
  width: 100%;
`;

export const FilterColumn = styled(Box)`
  display: flex;
  flex-direction: column;
`;
